module.exports = __webpack_public_path__ + "static/media/método_de_las_5_s.3a69021a.png";